import type { Announcement } from '../types';

export const a_2026_07_03: Announcement = {
  id: '2026-07-03-memoire-hector',
  date: '2026-07-03',
  layout: 'spotlight',
  kicker: 'Mise à jour produit · 3 juillet 2026',
  title: "Hector s'améliore : une mémoire de travail pour Hector",
  navLabel: 'Mémoire Hector',
  subtitle: '',
  intro: [
    "Hector retient désormais davantage le fil de votre travail : les actes générés, les conversations que vous avez eues, vos préférences de travail, ainsi que les dernières discussions et décisions prises dans un dossier.",
    "Vous pouvez bien sûr modifier à tout moment les informations enregistrées et conservées pour améliorer la personnalisation de l'outil.",
  ],
  introCallout: {
    text: "Consultez dès maintenant ce qu'Hector a retenu de vous sur les deux derniers jours.",
    cta: {
      label: 'Voir la mémoire (cliquez ici)',
      // La Mémoire a été rapatriée de Paramètres vers Personnalisation (2026-07-25) — l'ancre
      // `memoire` est reconnue par Personnalisation.tsx.
      url: 'https://app.hector.legal/personnalisation#memoire',
    },
  },
  sections: [
    {
      label: 'Ce que cela change',
      features: [
        {
          id: 'memoire-dossier',
          title: 'Un meilleur suivi de chaque dossier',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "À la fin d'une conversation, Hector met à jour la mémoire utile du dossier : ce qui a été discuté, les choix retenus et les points importants à conserver pour la suite.",
            ],
          },
        },
        {
          id: 'memoire-visible',
          title: 'Une mémoire que vous pouvez consulter',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "L'onglet dédié vous permet de relire ce qui a été conservé et de corriger ou compléter ces informations quand vous le souhaitez.",
            ],
          },
        },
        {
          id: 'memoire-quotidienne',
          title: 'Un retour sur le travail de la journée',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "En fin de journée, Hector revient sur le travail réalisé afin de consolider les éléments importants et de garder une continuité entre vos échanges.",
            ],
          },
        },
        {
          id: 'preferences-travail',
          title: 'Vos préférences mieux prises en compte',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "L'assistant peut aussi s'appuyer sur vos préférences de travail pour produire des réponses plus proches de votre manière habituelle de traiter vos dossiers.",
            ],
          },
        },
      ],
    },
  ],
};
